import React from "react";
import { Router } from "./router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BetterAuthSessionBootstrap } from "components/auth/BetterAuthSessionBootstrap";

const App = () => {
  return (
    <>
      <BetterAuthSessionBootstrap>
        <Router />
      </BetterAuthSessionBootstrap>
      <ToastContainer closeButton={false} icon={false} />
    </>
  );
};

export default App;
